document.addEventListener("DOMContentLoaded", function () {
  // only run on screen widths <= 768px
  if (!window.matchMedia("(max-width: 1024px)").matches) return;

  document.querySelectorAll('variant-radios[data-product-type="card"]').forEach(function (card) {
    const wrapper = card.closest('.card, .card-wrapper, .product-card, .grid__item, article, li') || card.parentElement;
    if (!wrapper) return;

    if (wrapper.querySelector('.variant-names-line')) return;

    const tooltips = card.querySelectorAll('.tooltip.tooltip--top');
    const values = Array.from(tooltips).map(t => t.textContent.trim()).filter(Boolean);
    const uniqueValues = Array.from(new Set(values));
    if (uniqueValues.length === 0) return;

    const line = document.createElement('div');
    line.className = 'variant-names-line';
    line.textContent = uniqueValues.join(' | ');

    const descSpans = wrapper.querySelectorAll('span.caption-large.light');
    const target = descSpans[descSpans.length - 1];
    if (target) {
      target.insertAdjacentElement('afterend', line);
    } else {
      const swatchCol = card.querySelector('.product-form__column') || card;
      swatchCol.insertAdjacentElement('beforebegin', line);
    }
  });
});
